import { ArrowLeftIcon, ChevronLeftIcon } from "@heroicons/react/20/solid";
import { useMatch, useNavigate, useParams } from "react-router";
import { Headline } from "./Headline";
import { UserActions } from "./Header";

export default function DetailHeader({ children }) {
  // const selectedCustomer = useSelectedCustomer();
  const { id } = useParams();
  const match = useMatch(`/${id}`);

  const inIFrame = window.top !== window.self;
  const navigate = useNavigate();
  return (
    <div className="mb-6 sticky top-0 pt-3 z-50 bg-white border-b pb-3">
      <div className="px-4 flex justify-between items-center">
        <div className="flex items-center gap-3 w-full">
          {inIFrame && match ? null : (
            <ChevronLeftIcon
              className="w-6 h-6"
              onClick={() => navigate("./..")}
            />
          )}
          <Headline className="font-bold w-full">{children}</Headline>
        </div>
        {!inIFrame && <UserActions token={null} env={null} />}
      </div>
    </div>
  );
}
